import { render, staticRenderFns } from "./LessonExercisesWidget.vue?vue&type=template&id=79074067&scoped=true"
import script from "./LessonExercisesWidget.vue?vue&type=script&lang=js"
export * from "./LessonExercisesWidget.vue?vue&type=script&lang=js"
import style0 from "./LessonExercisesWidget.vue?vue&type=style&index=0&id=79074067&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79074067",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79074067')) {
      api.createRecord('79074067', component.options)
    } else {
      api.reload('79074067', component.options)
    }
    module.hot.accept("./LessonExercisesWidget.vue?vue&type=template&id=79074067&scoped=true", function () {
      api.rerender('79074067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LessonExercisesWidget.vue"
export default component.exports